// extracted by mini-css-extract-plugin
export default {"heading":"EditCouponDetails_heading__jfhBX","wrapper":"EditCouponDetails_wrapper__zr1Vv","addProductBtnContainer":"EditCouponDetails_addProductBtnContainer__gfHRV"};